<template>
    <div 
        v-tinymce="options"
        :key="renderKey"
        @mce-change="(content) => offerSectionSet({seminarContent: content})"
        @mce-dirty="() => $emit('dirty')"
    >
        <div v-if="offerSections.seminarContent" v-html="offerSections.seminarContent"></div>
        <b-card v-else class="seminar-content">
            <b-row>
                <b-col md="12">
                    <h4>{{ $t('seminarContent.heading') }}</h4>
                    <h3>{{ (offer && offer.title) ? offer.title : seminar.title }}</h3>
                </b-col>
            </b-row>
            <b-row >
                <b-col 
                    class="agenda" 
                    v-html="seminar.content"
                ></b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
    name: 'SeminarContent',
    props: {
        options: Object,
    },
    computed: {
        ...mapGetters([
            'offer',
            'seminar',
            'offerSections'
        ])
    },
    data() {
        return {
            renderKey:0,
        }
    },
    methods: {
        ...mapMutations([
            'offerSectionSet'
        ]),
    },
    watch: {
        seminar: function (){
            this.renderKey++;
        }
    }
}
</script>

<style scoped>
    .agenda {
        column-count:2
    }
    .mce-edit-focus .agenda {
        column-count:auto;
    }
    .separator {
        content: ""; 
        border: 1px solid #ddd;
        height: 100%;
        position: absolute;
        top: 0px;
        cursor: pointer;
        left: 50%;
    }
</style>

<style>
    .seminar.imported ul {
        padding-left: 0;
        list-style-type: none !important;
    }
</style>
